import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import { ReactComponent as EditIcon } from "../../assets/icons/edit.svg";
import MultiSelect from "../../components/DataEntry/MultiSelect";
import { useLocation } from "react-router-dom";
import { savePathToLocalStorage } from "../../utils/helpers";

const Support = () => {
  savePathToLocalStorage();
  return (
    <div>
      <Header title="Support" />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          cursor: "pointer",
          width: "100%",
        }}
      >
        <p
          style={{
            margin: "0 auto",
            textTransform: "uppercase",
          }}
        >
          To be implemented
        </p>
      </div>
    </div>
  );
};
export default Support;
